import type { Rect } from './Rect';

function intersectRect(r1: Rect, r2: Rect) {
  return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
}

export function isIntersected(
  elementRect: Rect,
  cursorX: number,
  cursorY: number,
  gradientSize: number
) {
  const cursorArea = {
    left: cursorX - gradientSize,
    right: cursorX + gradientSize,
    top: cursorY - gradientSize,
    bottom: cursorY + gradientSize,
  };

  return intersectRect(cursorArea, elementRect);
}
